import React from "react";

export const Video = () => {
    return (
        <div>
            <iframe src="https://www.youtube.com/embed/videoseries?list=PLTEzkRjWlPyQhKteW1xKjNGv42h0-kzTr" width="480"
                    height="400"></iframe>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/Pages/Video.js